import { ImageFromServer } from '@/components/images/ImageFromServer';
import { Box, Tooltip, Typography } from '@mui/material';
import { ReactElement } from 'react';

type ItemPreviewTooltipProps = {
  children: ReactElement;
  name: string;
  description?: string;
  imageId?: string;
  additionalText?: string;
};

export const ItemPreviewTooltip = (props: ItemPreviewTooltipProps) => (
  <Tooltip
    arrow
    placement="right"
    slotProps={{ tooltip: { sx: { maxWidth: 'none', overflow: 'hidden' } } }}
    title={
      <Box sx={{ width: 320, maxWidth: 'calc(100vw - 48px)', boxSizing: 'border-box', overflow: 'hidden', p: 0.75 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: '88px minmax(0, 1fr)', gap: 1.25, alignItems: 'start' }}>
          <ImageFromServer
            sx={{ width: 88, height: 88, objectFit: 'contain', borderRadius: 1, backgroundColor: 'common.white' }}
            thumbnail
            alt=""
            id={props.imageId}
          />
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
              {props.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', overflowWrap: 'anywhere', wordBreak: 'break-word' }}
            >
              {props.description || 'No description'}
            </Typography>
          </Box>
        </Box>
        {props.additionalText && (
          <Typography
            variant="caption"
            sx={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', overflowWrap: 'anywhere', wordBreak: 'break-word', mt: 1, pt: 0.75, borderTop: 1, borderColor: 'divider' }}
          >
            {props.additionalText}
          </Typography>
        )}
      </Box>
    }
  >
    {props.children}
  </Tooltip>
);
